interface TopBarProps {
  onBack: () => void;
  onHome: () => void;
  /** 진입 화면 등 이전 단계가 없을 때 뒤로가기를 숨긴다 */
  showBack?: boolean;
  /** 진입 화면 등 이동할 곳이 없을 때 홈을 숨긴다 */
  showHome?: boolean;
  /** 배경 클래스 (게임 화면에서는 페이지 배경과 동일하게 이어지도록) */
  backgroundClassName?: string;
}

// 신한 SOL WebView 스타일 상단 네비게이션 바
// - 좌측: 뒤로가기, 우측: 홈 (게임 정보는 넣지 않음)
export default function TopBar({
  onBack,
  onHome,
  showBack = true,
  showHome = true,
  backgroundClassName = 'bg-white',
}: TopBarProps) {
  return (
    <div className={`h-[var(--sh-topbar-height)] shrink-0 flex items-center justify-between px-2 ${backgroundClassName} relative z-20`}>
      {showBack ? (
        <button
          onClick={onBack}
          className="w-10 h-10 flex items-center justify-center rounded-full text-foreground-900
            active:bg-background-100 transition-colors duration-150 cursor-pointer"
          aria-label="뒤로"
        >
          <i className="ri-arrow-left-s-line text-2xl leading-none" />
        </button>
      ) : (
        <span className="w-10 h-10" />
      )}
      {showHome ? (
        <button
          onClick={onHome}
          className="w-10 h-10 flex items-center justify-center rounded-full text-foreground-900
            active:bg-background-100 transition-colors duration-150 cursor-pointer"
          aria-label="홈"
        >
          <i className="ri-home-5-line text-xl leading-none" />
        </button>
      ) : (
        <span className="w-10 h-10" />
      )}
    </div>
  );
}